<template>
  <div class="page_matching">
    <Htitle title="人岗匹配"></Htitle>
    <div class="candidateInfo" v-infinite-scroll="load" infinite-scroll-disabled="disabled">
      <div class="matchin_jobLIst" :class="index==0 ? 'first' : ''" v-for="(item,index) in joblist
      " :key="index">
        <div class="jobItem flex">
          <div class="jobItem_box">
            <div class="jobItem_box_top flex sb">
              <div>项目：{{ item.StrprojectName }}</div>
              <div>薪资：{{ item.ComprehensiveSalary }} / {{ item.PayType=='月薪' ? '月' : '天'}}</div>
            </div>
            <div style="margin-top: 10px;">岗位：{{ item.JobCategory }}</div>
          </div>
          <div class="matchin_btnBox">
            <el-popover placement="left" title="" width="150" trigger="click">
              <el-image style="width: 150px; height: 150px" :src="item.canvasImg" :preview-src-list=[item.canvasImg]>
              </el-image>
              <div class="matchin_btn" slot="reference" @click="getQRcode(item)">发送</div>
            </el-popover>
            <div class="matchin_btn btn_bot" @click="showAppointment(item)">约面</div>
          </div>
        </div>
      </div>
      <div v-if="!loading && joblist.length==0">
        <el-empty description="暂无匹配岗位">
          <el-button type="primary" @click="refresh()">刷新</el-button>
        </el-empty>
      </div>
      <p class="loadtxt" v-if="loading">加载中...</p>
      <p class="loadtxt" v-if="noMore && joblist.length>0">没有更多了</p>

      <!-- <div class="matchin_bot_btnBox">
        <div class="matchin_btn matchin_bot_btn">一键匹配</div>
      </div> -->
    </div>

    <!-- <van-popup v-model="showSexSelect" position="bottom">
      <van-picker title="选择性别" show-toolbar :columns="sexList" @confirm="onConfirmSex" @cancel="showSexSelect = false" />
    </van-popup>

    <van-popup v-model="showNation" position="bottom">
      <van-picker title="选择民族" show-toolbar :columns="nationals" @confirm="onConfirmNation" @cancel="showNation = false" />
    </van-popup>

    <van-popup v-model="showWorkingShift" position="bottom">
      <van-picker title="选择班次" show-toolbar :columns="shiftList" value-key="Name" @confirm="onConfirmWorkingShift" @cancel="showWorkingShift = false" />
    </van-popup> -->

    <van-popup v-model="showInterTime" position="bottom" z-index="3000">
      <van-picker title="选择面试时间" show-toolbar :columns="interTimeList" value-key="time" @confirm="onConfirmTime" @cancel="showInterTime = false" />
    </van-popup>

    <el-dialog title="约面" :visible.sync="aptVisible" width="90%" class="res_dialog" z-index="2000">
      <van-field required v-model="aptQuery.Dtviewtime" is-link readonly label="面试时间" placeholder="请选择面试时间" @click="showInterTime = true" label-width="4em" />
      <span slot="footer" class="dialog-footer">
        <div class="flex">
          <div class="footerBtn leftbtn" @click="aptVisible = false">取消</div>
          <div class="footerBtn" @click="confirmApp">确定</div>
        </div>
      </span>
    </el-dialog>
  </div>
</template>
    
<script>
import xz from "@/common";
import Htitle from "./components/header.vue";
import moment from 'moment'
export default {
  components: {
    Htitle
  },
  data() {
    return {
      roletype: localStorage.loginRoletype,
      listQuery: {
        ResumeId: '',
        pageNum: 1,
        pageSize: 5
      },
      //岗位列表
      joblist: [],
      loading: false,
      total: 0,
      //约面弹窗
      aptVisible: false,
      //约面参数
      aptQuery: {
        Jobid: '', //岗位id
        Projectid: '', //项目id
        Belonguserid: Cookies.get("userid-b"), //创建人
        ResumeId: '', //简历ID
        StrState: '约面', //当前状态
        StrUserName: '', //姓名
        StrMobile: '', //联系方式
        StrUserCity: '', //求职城市
        StrUserCityCode: '', //求职城市
        StrRemark: '', //备注
        StrUserAge: '', //年龄
        BolUserSex: '', //性别
        Dtviewtime: '', //面试时间
        Strviewadd: '', //面试地址
        StrPsnIsType: 0
      },
      //面试时间
      interTimeList: [],
      //选择面试时间
      showInterTime: false,
    }
  },
  async created() {
    if (!this.isNull(this.$route.query.ResumeId)) {
      this.listQuery.ResumeId = this.$route.query.ResumeId;
      this.aptQuery.ResumeId = this.$route.query.ResumeId;
      this.getMatchJob()
    }
  },
  computed: {
    noMore() {
      return this.joblist.length >= this.total
    },
    disabled() {
      return this.loading || this.noMore
    }
  },
  mounted() { },
  methods: {
    //获取岗位列表
    getMatchJob() {
      this.loading = true;
      xz.gettencentwxrecruitmentplanjob(this.listQuery, this.roletype).then(res => {
        if (res.status == 'ok') {
          this.total = res.data.Count;
          if (res.data.Count != 0) {
            this.joblist = res.data.retList;
          }else{
            this.joblist = []
          }
          this.loading = false;
        } else {
          this.loading = false;
          this.$toast.fail('系统出错');
        }
      })
    },
    //触底加载
    load() {
      this.loading = true;
      this.listQuery.pageNum = this.listQuery.pageNum + 1;
      xz.gettencentwxrecruitmentplanjob(this.listQuery, this.roletype).then(res => {
        if (res.status == 'ok') {
          this.joblist.push(...res.data.retList);
          this.total = res.data.Count;
          this.loading = false;
        } else {
          this.$toast.fail('系统出错');
          this.loading = false;
        }
      })
    },
    //约面弹窗
    showAppointment(item) {
      this.aptVisible = true;
      this.aptQuery.Jobid = item.Id;
      this.aptQuery.Projectid = item.Projectid;
      this.getInterTime(item.Id);
    },
    //获取面试时间
    getInterTime(Id) {
      let nowdate = moment().format("YYYY-MM-DD HH:mm")
      let endDate = moment().add(1, 'months').format("YYYY-MM-DD HH:mm")
      let viewTimeQuery = {
        interviewStartTime: nowdate,
        interviewEndTime: endDate
      }
      xz.getresourceavailabletime(Id, viewTimeQuery).then(res => {
        if (res.status == 'ok') {
          this.interTimeList = res.data.tempList;
        }
      })
    },
    //选择时间
    onConfirmTime(v) {
      console.log(v)
      this.aptQuery.Dtviewtime = v.time.substring(0, 16);
      this.showInterTime = false;
    },
    confirmApp() {
      if (!this.aptQuery.Dtviewtime) {
        this.$toast('请选择面试时间')
        return
      }
      let data = [{
        resumeId: this.aptQuery.ResumeId, // 简历id
        projectid: this.aptQuery.Projectid, // 项目id
        jobid: this.aptQuery.Jobid // 岗位id
      }]
      xz.getresumestatuscheck('约面', data).then(res => {
        if (res.status == 'ok') {
          if (res.msg[0].Strremind) {
            this.$toast(res.msg[0].Strremind)
          } else {
            this.submit()
          }
        }
      })
    },
    submit() {
      xz.saveSigninfo(this.aptQuery).then(res => {
        this.$toast({
          type: res.status == 'ok' ? 'success' : 'fail',
          message: res.status == 'ok' ? '约面成功！' : '系统出错'
        })
        this.aptVisible = false
      })
    },
    //获取招聘二维码
    getQRcode(item) {
      let data = {
        Id: item.Id, // 岗位ID
        pagepath: 'pages/enter/enter', // 页面URL
        strLinkType: 'A' //A-报名二维码，B-到面二维码,C-入职二维码 D-简历采集二维(ID传空)
      }
      xz.getapplyjoobqrcodegenerated(this.roletype, data).then(res => {
        if (res.status == 'ok') {
          let canvasImg = this.$store.state.EMP.imgPath + res.data;
          this.$set(item, 'canvasImg', canvasImg)
        }
      })
    },
    refresh() {
      this.listQuery.pageNum = 1;
      this.getMatchJob();
    },
    //判断是否为空(包含0)
    isNull(o) {
      return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN' || o == ('1900-01-01') || o == '1900-01-01T00:00:00';
    }
  }
}

  </script>
 <style scoped>
.page_matching {
  background: #f2f2f2;
  padding: 0 12px 20px;
  font-size: 14px;
  font-family: "PingFangSC-Regular", "PingFang SC", sans-serif;
  height: 100vh;
  overflow: auto;
}
.candidateInfo_title {
  margin-bottom: 15px;
  overflow: auto;
}
.first {
  margin-top: 10px !important;
}
.matchin_jobLIst {
  margin-top: 30px;
}
.jobItem_box {
  width: calc(100% - 90px);
  background: #d7d7d7;
  padding: 15px 30px 15px 10px;
  border-radius: 5px;
}
.matchin_btnBox {
  margin-left: 10px;
  width: 53px;
}
.matchin_btn {
  height: 45%;
  background: #fff;
  border: 1px solid rgba(121, 121, 121, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  border-radius: 5px;
}
.btn_bot {
  margin-top: 5%;
}
.matchin_bot_btnBox {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.matchin_bot_btn {
  width: 140px;
  height: 40px;
}
.loadtxt {
  width: 100%;
  text-align: center;
  padding: 5px 0;
  font-size: 12px;
  color: #333;
}
.footerBtn {
  width: 50%;
  text-align: center;
  border-top: 1px solid #f7f8f9;
  padding-top: 10px;
}
.leftbtn {
  border-right: 1px solid #f7f8f9;
}
</style>
<style>
.page_matching .van-field__label {
  width: 7em;
}
</style>
    
 